import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#__clip0_1121_3380)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M19.999 4.75166L15.7886 9.05264V5.99362H11.0234V10.6745C11.0234 11.6102 10.2513 12.3092 9.37368 12.3092H4.2104V15.3684L0 11.0675L4.2104 6.94764V10.0067H8.72082V5.32575C8.72082 4.39007 9.49288 3.69105 10.3705 3.69105H15.7886V0.631836L19.999 4.75166Z",
        fill: "#4F4F4F"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "__clip0_1121_3380" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "16",
          fill: "white"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }